import BeAwareTabs from "./BeAwareMobileContent/BeAwareTabs"



const BeAware = () => {
  return (
    <>
      <BeAwareTabs/>
    </>
  )
}

export default BeAware